module.exports = __webpack_public_path__ + "img/dark_float_ico.c7f9b478.png";